module.exports = __webpack_public_path__ + "static/media/tg.025deae8.svg";